import storeEvent from "../../utils/store-event";
import { get } from "../../utils/object-helpers";

class {
    onCreate(input) {
        this.state = {
            drawerOpen: false,
            share: null
        };
        const socialModule = get(input, 'page.modules.SHARE_MODULE', null);
        if (socialModule) {
            this.state.share = {
                pageId: get(socialModule, 'shareAction.action.params.pageId', '3418065'),
                storeUrlId: get(socialModule, 'shareAction.action.params.storeUrlId', ''),
                categoryType: get(socialModule, 'shareAction.action.params.categoryType', ''),
                categoryId: get(socialModule, 'shareAction.action.params.categoryId', ''),
                enableSharedCheckmark: true,
                shareSectionTitle: get(socialModule, 'shareAction.action.params.shareSectionTitle', ''),
                a11yCloseText: get(socialModule, 'shareAction.action.params.a11yCloseText', ''),
                a11yMinimizeText: get(socialModule, 'shareAction.action.params.a11yMinimizeText', ''),
                a11yMaximizeText: get(socialModule, 'shareAction.action.params.a11yMaximizeText', ''),
                a11ySpinnerText: get(socialModule, 'shareAction.action.params.a11ySpinnerText', ''),
                a11yAttentionText: get(socialModule, 'shareAction.action.params.a11yAttentionText', ''),
                defaultErrorMessage: get(socialModule, 'shareAction.action.params.defaultErrorMessage', '')
            };
        }
    }
    onMount() {
        const drawer = document.querySelector('.str-share-drawer');
        if (drawer) {
            const closeBtn = drawer.querySelector('.drawer-dialog__close');
            storeEvent.openShareDrawer.listen(() => {
                this.state.share.initGenericShare = true;
                this.state.drawerOpen = true;
                closeBtn.focus();
            });
        }
    }
    closeDrawer() {
        this.state.drawerOpen = false;
    }
}

<if(state.share)>
    <ebay-drawer-dialog
        class="str-share-drawer"
        a11y-close-text=state.share.a11yCloseText
        aria-labelledby="str-share-drawer-title"
        open=state.drawerOpen
        on-close("closeDrawer")
        on-expanded("emit", "expanded")
        on-collapsed("emit", "collapsed")
        on-open("emit", "open")>
        <@header id="str-share-drawer-title">
            <span>${state.share.shareSectionTitle}</span>
        </@header>
        <!--
        // str-generic-social-share-template only works if initialized in browser.
        -->
        <if(state.share.initGenericShare)>
            <str-generic-social-share-template model=state.share />
        </if>
    </ebay-drawer-dialog>
</if>
